import { supabase } from '../config/supabaseClient';

// ── Albums ────────────────────────────────────────────────────────────────────

export async function getAlbumes() {
  const { data, error } = await supabase
    .from('galeria_albumes')
    .select('*')
    .order('sort_order', { ascending: true })
    .order('name', { ascending: true });
  if (error) throw error;
  return data;
}

export async function createAlbum(album) {
  const { data, error } = await supabase
    .from('galeria_albumes')
    .insert([album])
    .select()
    .single();
  if (error) throw error;
  return data;
}

export async function updateAlbum(id, album) {
  const { data, error } = await supabase
    .from('galeria_albumes')
    .update(album)
    .eq('id', id)
    .select()
    .single();
  if (error) throw error;
  return data;
}

export async function deleteAlbum(id) {
  const { error } = await supabase
    .from('galeria_albumes')
    .delete()
    .eq('id', id);
  if (error) throw error;
}

// ── Photos ────────────────────────────────────────────────────────────────────

export async function getGaleriaFotos() {
  const { data, error } = await supabase
    .from('galeria_fotos')
    .select('*, galeria_albumes(id, name, date, sort_order)')
    .order('sort_order', { ascending: true })
    .order('created_at', { ascending: true });
  if (error) throw error;
  return data;
}

export async function createGaleriaFoto(foto) {
  const { data, error } = await supabase
    .from('galeria_fotos')
    .insert([foto])
    .select()
    .single();
  if (error) throw error;
  return data;
}

export async function updateGaleriaFoto(id, foto) {
  const { data, error } = await supabase
    .from('galeria_fotos')
    .update(foto)
    .eq('id', id)
    .select()
    .single();
  if (error) throw error;
  return data;
}

export async function deleteGaleriaFoto(id) {
  const { error } = await supabase
    .from('galeria_fotos')
    .delete()
    .eq('id', id);
  if (error) throw error;
}

export async function updateAlbumSortOrder(albumId, sortOrder) {
  const { error } = await supabase
    .from('galeria_albumes')
    .update({ sort_order: sortOrder })
    .eq('id', albumId);
  if (error) throw error;
}

export async function getHomeCarouselFotos() {
  const { data, error } = await supabase
    .from('galeria_fotos')
    .select('id, image_url, title')
    .eq('show_in_home', true)
    .order('sort_order', { ascending: true })
    .order('created_at', { ascending: true });
  if (error) throw error;
  return data;
}

export async function toggleShowInHome(id, value) {
  const { error } = await supabase
    .from('galeria_fotos')
    .update({ show_in_home: value })
    .eq('id', id);
  if (error) throw error;
}
